import { render, staticRenderFns } from "./DeliveryMethodsListItem.vue?vue&type=template&id=09dc952a&scoped=true"
import script from "./DeliveryMethodsListItem.vue?vue&type=script&lang=js"
export * from "./DeliveryMethodsListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09dc952a",
  null
  
)

export default component.exports